<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="DateTime"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' @child-event='getTextVal' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>
    <div v-if="listIsShow" class="pricing-list">
      <div class="totle">
        共计<span>{{ borrowingList.length }}</span
      >条
      </div>
      <div
          class="pricing-item"
          v-for="(item, index) in borrowingList"
          :key="index"
          ref="itm"
          @click="look(index,item)"
      >
        <div class="title">拿取记录</div>
        <div class="applicant-time clearfix">
          <div class="applicant">
            拿取者：{{ item.ConferenceRoomTake.Name }} {{item.ConferenceRoomTake.EmpNo}} {{item.ConferenceRoomTake.DeptName}}
          </div>
          <div class="applicant">
            会议室名称: {{ item.ConferenceRoomTake.MeetingRoomName }}
          </div>
          <div class="applicant">
            物品: {{item.ConferenceRoomTake.ArticleName | coverArticleName}}
          </div>
          <div class="applicant">
             拿取时间: {{ item.ConferenceRoomTake.Time }}
          </div>
        </div>
      </div>
    </div>
    <Button
        class="submit-process"
        v-on:click="submit"
        v-bind:disabled="isDisabled"
        v-bind:loading="formLoading"
        size="large"
        type="primary"
    >
      归还
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from "../components/DateTime.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import stringUtils from "../assets/js/stringUtil.js";
import {initWxConfig} from "../api/jssdk.js";
import {getTemplateInfo, submitProcessCopy} from "@/api/approval";
import {getRelation} from "@/api/employee";

import {
  returneeInformationFill,
  getMeetingRoomArticleOfTake,
  conferenceRoomBackFill
} from "@/api/ResourceBorrowing";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates,
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      listIsShow:false,
      equipmentName:null,
      borrowingList: [],
      resourceBorrowing: null,
      toDay:null,
      FlowId:''
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  filters:  {
    coverArticleName:function(values){
      let result = '';
      if (values != null && values.length > 0){
        for (let i = 0; i < values.length; i++) {
          if (i !== values.length - 1){
            result += `${values[i]},`
          }else{
            result += values[i]
          }
        }
        return result
      }
      return result;
    }
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation(val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getSelectorVal:async function(val, name) {
    },
    getTextVal() {},
    buildObject(){
      var ReturneeInformation = {
        /**
         * 归还者姓名
         * */
        Name:'',
        /**
         * 归还者工号
         */
        EmpNo:'',
        /**
         * 归还者部门
         */
        DeptName:'',
        /**
         * 归还时间
         */
        Time:''
      }
      return this.filling(ReturneeInformation);
    },
    /**
     * 填充数据
     * @param obj
     * @returns {*}
     */
    filling(obj){
      obj.Name = this.logInfo.EmpName
      obj.EmpNo = this.logInfo.EmpNo
      obj.DeptName = this.logInfo.DeptName
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = `${data.getFullYear()}-${month}-${date} ${data.getHours()}:${data.getMinutes() > 9 ? data.getMinutes() : '0'+data.getMinutes()}:${data.getSeconds() > 9 ? data.getSeconds() : '0' + data.getSeconds()}`
      this.toDay = dateTime
      obj.Time = dateTime
      return obj
    },
    look(index,item){
      this.isDisabled = false
      for (let i = 0; i < this.$refs.itm.length; i++) {
        let dom = this.$refs.itm[i];
        dom.className = "pricing-item";
      }
      this.$refs.itm[index].className = "pricing-item pricing-list-current";
      this.resourceBorrowing = item;
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "流程编号"){
          item.Value = this.resourceBorrowing.FlowId;
        }
        if (item.Property.Title[0].Text === "关联申请单"){
          item.IsShow = true
          this.spNo = this.resourceBorrowing.ApprovalNumber
          this.$set(item,'Value',this.resourceBorrowing.ApprovalNumber)
        }
      })
    },
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      that.isDisabled = true
      let a = true;
      if(a){
        this.Message({
          message: "禁止使用",
          type: "error",
          duration: 3 * 1000,
        });
        this.isDisabled = true;
      }
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      await getTemplateInfo(this.templateId).then((response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++) {
          let item = controls.TemplateContent.Controls[i];
          if (item.Property.Title[0].Text === "拿取记录"){
            item.IsShow = false;
            item.Value = "无拿取记录";
            this.Disable = true
          }
          if (item.Property.Title[0].Text === "归还者"){
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === "姓名"){
                child.Value = that.logInfo.EmpName
                child.Disable = true
              }
              if (child.Property.Title[0].Text === "工号"){
                child.Value = that.logInfo.EmpNo
                child.Disable = true
              }
              if (child.Property.Title[0].Text === "部门"){
                child.Value = that.logInfo.DeptName
                child.Disable = true
              }
            })
          }
          if (item.Property.Title[0].Text === "拿取人信息"){
            item.IsShow = false
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
      getMeetingRoomArticleOfTake().then(res => {
        let bodys = res.Body;
        if (bodys !== null && bodys.length > 0) {
          this.listIsShow = true
          this.borrowingList = []
          bodys.forEach(body => {
            this.borrowingList.push(body)
          })
        }else{
          this.listIsShow = false
          this.borrowingList = []
          this.templateData.TemplateContent.Controls.forEach(item => {
            if (item.Property.Title[0].Text === "拿取记录"){
              item.IsShow = true;
              this.Message({
                message: "无拿取记录",
                type: "error",
                duration: 3 * 1000,
              });
              this.isDisabled = true;
            }
          })
        }
      })
    },
    submit: async function () {
      this.isDisabled = true;
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }

      //构建
      var returneeInformation = this.buildObject();
      console.log(returneeInformation)
      //审批人所见
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "拿取人信息"){
          let children = item.Config.Table.Children;
          children.forEach(child => {
            if (child.Property.Title[0].Text === "拿取者姓名"){
              child.Value = this.resourceBorrowing.ConferenceRoomTake.Name;
            }
            if (child.Property.Title[0].Text === "拿取者工号"){
              child.Value = this.resourceBorrowing.ConferenceRoomTake.EmpNo;
            }
            if (child.Property.Title[0].Text === "拿取者部门"){
              child.Value = this.resourceBorrowing.ConferenceRoomTake.DeptName;
            }
            if (child.Property.Title[0].Text === "会议室名称"){
              child.Value = this.resourceBorrowing.ConferenceRoomTake.MeetingRoomName;
            }
            if (child.Property.Title[0].Text === "拿取时间"){
              child.Value = this.resourceBorrowing.ConferenceRoomTake.Time;
            }
            if (child.Property.Title[0].Text === "物品名称"){
              let values = this.resourceBorrowing.ConferenceRoomTake.ArticleName;
              let result = ''
              for (let i = 0; i < values.length; i++) {
                if (i !== values.length - 1){
                  result += `${values[i]},`
                }else{
                  result += values[i]
                }
              }
              child.Value = result
            }
            if (child.Property.Title[0].Text === "归还时间"){
              child.Value = returneeInformation.Time;
            }
          })
        }
      })

      this.isDisabled = true;
      var SummaryList = [];

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: `归还者： ${this.logInfo.EmpName}  ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
        Lang: "zh_CN",
      });
      SummaryList.push(info);

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: `拿取时间 : ${this.resourceBorrowing.ConferenceRoomTake.Time}`,
        Lang: "zh_CN",
      });
      SummaryList.push(info);

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: `归还时间 : ${returneeInformation.Time}`,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList;
      //提交
      submitProcessCopy(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          {
            "dto":this.templateData,
          },
          this.resourceBorrowing.FlowId
      )
          .then((response) => {
            if (response.Body.ErrCode !== 0) {
              this.Message({
                message: "申请失败，请稍后重试",
                type: "error",
                duration: 3 * 1000,
              });
            }else{
              //保存数据
              conferenceRoomBackFill(this.resourceBorrowing.Id,returneeInformation)
              this.Message({
                message: "申请成功",
                type: "success",
                duration: 1000,
              });
              setTimeout(() => {
                this.$router.push("/index");
              }, 1000);
            }
          })
          .catch((err) => {
            this.isDisabled = false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.pricing-list {
  padding: 10px;
  margin-top: 0px;
  .totle {
    font-size: 12px;
    margin-top: 10px;
    span {
      color: #ff4346;
      padding: 0 4px;
    }
  }
  .pricing-item {
    width: 100%;
    background: #ffffff;
    position: relative;
    padding: 8px;
    margin-top: 10px;
    border-radius: 6px;
    box-shadow: 6px 6px 6px #cccccc;
    .title {
      font-size: 13px;
      color: #585354;
      line-height: 1.8;
      width: calc(100% - 40px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-bottom: 4px;
    }
    .applicant-time {
      color: #585354;
      font-size: 12px;
      line-height: 1.7;
      div.applicant {
        width: 80%;
        float: left;
      }
      div.time {
        width: 40%;
        float: right;
        text-align: right;
      }
    }
    .label {
      position: absolute;
      right: 5px;
      top: 10px;
    }
    .waiting-pricing {
      color: #3fc243;
    }
    .waiting-check {
      color: #55acee;
    }
  }
  .pricing-list-current{
    border: 2px solid #b9d5ec;
    box-shadow: 6px 6px 6px #78b4e6;
  }
  .pricing-item:first-child {
    margin-top: 0;
  }
}
</style>